import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './index';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE
  );

  const changeLanguage = async (langCode) => {
    try {
      await i18n.changeLanguage(langCode);
      localStorage.setItem('i18nextLng', langCode);
      setCurrentLanguage(langCode);
    } catch (error) {
      console.error('[i18n] Failed to change language:', error);
    }
  };

  useEffect(() => {
    const handleLanguageChanged = (lng) => setCurrentLanguage(lng);
    i18n.on('languageChanged', handleLanguageChanged);
    return () => i18n.off('languageChanged', handleLanguageChanged);
  }, [i18n]);

  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      changeLanguage,
      supportedLanguages: SUPPORTED_LANGUAGES,
      getCurrentLanguageLabel: () => {
        const lang = SUPPORTED_LANGUAGES.find(l => l.code === currentLanguage);
        return lang ? lang.nativeLabel : 'English';
      }
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
